/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 決済種別 (-1:汎用QR, 0:WechatPay, 1:ALIPay, 2:AEONPay, 3:R Pay, 5:PayPay, 6:メルペイ, 7:d払い, 8:LINEPay, 9:auPay, 10:J-Coin Pay, 11:銀聯QR, 12:Alipay+)
 * @export
 * @enum {number}
 */
export enum SettlementTypeEnum {
    /** 汎用QR */
    GENERIC_QR = '-1',
    /** WechatPay */
    WECHAT_PAY = '0',
    /** ALIPay */
    ALIPAY = '1',
    /** AEONPay */
    AEON_PAY = '2',
    /** R Pay */
    R_PAY = '3',
    /** PayPay */
    PAY_PAY = '5',
    /** メルペイ */
    MERPAY = '6',
    /** d払い */
    D_PAY = '7',
    /** LINEPay */
    LINE_PAY = '8',
    /** auPay */
    AU_PAY = '9',
    /** J-Coin Pay */
    J_COIN_PAY = '10',
    /** 銀聯QR */
    UNION_PAY_QR = '11',
    /** Alipay+ */
    ALIPAY_PLUS = '12'
}

/**
 * 決済種別 (-1:汎用QR, 0:WechatPay, 1:ALIPay, 2:AEONPay, 3:R Pay, 5:PayPay, 6:メルペイ, 7:d払い, 8:LINEPay, 9:auPay, 10:J-Coin Pay, 11:銀聯QR, 12:Alipay+) の Union 型
 * @export
 * @typedef SettlementType
 */
export type SettlementType =
  typeof SettlementTypeEnum[keyof typeof SettlementTypeEnum];

/**
 * 決済種別 (-1:汎用QR, 0:WechatPay, 1:ALIPay, 2:AEONPay, 3:R Pay, 5:PayPay, 6:メルペイ, 7:d払い, 8:LINEPay, 9:auPay, 10:J-Coin Pay, 11:銀聯QR, 12:Alipay+) のラベルマップ
 * @export
 */
export const SettlementTypeLabels = {
    /**
     * 数値キー: SettlementTypeEnum.GENERIC_QR
     * 名前キー:  GENERIC_QR
     */
    [SettlementTypeEnum.GENERIC_QR]: '汎用QR',
    GENERIC_QR:                             '汎用QR',
    /**
     * 数値キー: SettlementTypeEnum.WECHAT_PAY
     * 名前キー:  WECHAT_PAY
     */
    [SettlementTypeEnum.WECHAT_PAY]: 'WechatPay',
    WECHAT_PAY:                             'WechatPay',
    /**
     * 数値キー: SettlementTypeEnum.ALIPAY
     * 名前キー:  ALIPAY
     */
    [SettlementTypeEnum.ALIPAY]: 'ALIPay',
    ALIPAY:                             'ALIPay',
    /**
     * 数値キー: SettlementTypeEnum.AEON_PAY
     * 名前キー:  AEON_PAY
     */
    [SettlementTypeEnum.AEON_PAY]: 'AEONPay',
    AEON_PAY:                             'AEONPay',
    /**
     * 数値キー: SettlementTypeEnum.R_PAY
     * 名前キー:  R_PAY
     */
    [SettlementTypeEnum.R_PAY]: 'R Pay',
    R_PAY:                             'R Pay',
    /**
     * 数値キー: SettlementTypeEnum.PAY_PAY
     * 名前キー:  PAY_PAY
     */
    [SettlementTypeEnum.PAY_PAY]: 'PayPay',
    PAY_PAY:                             'PayPay',
    /**
     * 数値キー: SettlementTypeEnum.MERPAY
     * 名前キー:  MERPAY
     */
    [SettlementTypeEnum.MERPAY]: 'メルペイ',
    MERPAY:                             'メルペイ',
    /**
     * 数値キー: SettlementTypeEnum.D_PAY
     * 名前キー:  D_PAY
     */
    [SettlementTypeEnum.D_PAY]: 'd払い',
    D_PAY:                             'd払い',
    /**
     * 数値キー: SettlementTypeEnum.LINE_PAY
     * 名前キー:  LINE_PAY
     */
    [SettlementTypeEnum.LINE_PAY]: 'LINEPay',
    LINE_PAY:                             'LINEPay',
    /**
     * 数値キー: SettlementTypeEnum.AU_PAY
     * 名前キー:  AU_PAY
     */
    [SettlementTypeEnum.AU_PAY]: 'auPay',
    AU_PAY:                             'auPay',
    /**
     * 数値キー: SettlementTypeEnum.J_COIN_PAY
     * 名前キー:  J_COIN_PAY
     */
    [SettlementTypeEnum.J_COIN_PAY]: 'J-Coin Pay',
    J_COIN_PAY:                             'J-Coin Pay',
    /**
     * 数値キー: SettlementTypeEnum.UNION_PAY_QR
     * 名前キー:  UNION_PAY_QR
     */
    [SettlementTypeEnum.UNION_PAY_QR]: '銀聯QR',
    UNION_PAY_QR:                             '銀聯QR',
    /**
     * 数値キー: SettlementTypeEnum.ALIPAY_PLUS
     * 名前キー:  ALIPAY_PLUS
     */
    [SettlementTypeEnum.ALIPAY_PLUS]: 'Alipay+',
    ALIPAY_PLUS:                             'Alipay+',
} as const;

/**
 * 決済種別 (-1:汎用QR, 0:WechatPay, 1:ALIPay, 2:AEONPay, 3:R Pay, 5:PayPay, 6:メルペイ, 7:d払い, 8:LINEPay, 9:auPay, 10:J-Coin Pay, 11:銀聯QR, 12:Alipay+) のラベル Union 型
 * @export
 * @typedef SettlementTypeLabel
 */
export type SettlementTypeLabel =
  typeof SettlementTypeLabels[keyof typeof SettlementTypeLabels];

/**
 * 決済種別 (-1:汎用QR, 0:WechatPay, 1:ALIPay, 2:AEONPay, 3:R Pay, 5:PayPay, 6:メルペイ, 7:d払い, 8:LINEPay, 9:auPay, 10:J-Coin Pay, 11:銀聯QR, 12:Alipay+) のラベル取得関数
 * @export
 * @param { SettlementType } value - 列挙体の値
 * @returns { SettlementTypeLabel } ラベル文字列
 */
export function getSettlementTypeLabel(
  value: SettlementType
): SettlementTypeLabel {
  return SettlementTypeLabels[value];
}

/**
 * 決済種別 (-1:汎用QR, 0:WechatPay, 1:ALIPay, 2:AEONPay, 3:R Pay, 5:PayPay, 6:メルペイ, 7:d払い, 8:LINEPay, 9:auPay, 10:J-Coin Pay, 11:銀聯QR, 12:Alipay+) のラベル配列を取得する関数
 * @export
 * @param { SettlementType[] } values - 列挙体の値配列
 * @returns { SettlementTypeLabel[] } ラベル文字列配列
 */
export function getSettlementTypeLabels(values: SettlementType[]): SettlementTypeLabel[] {
  return values.map((value) => getSettlementTypeLabel(value));
}

/**
 * 決済種別 (-1:汎用QR, 0:WechatPay, 1:ALIPay, 2:AEONPay, 3:R Pay, 5:PayPay, 6:メルペイ, 7:d払い, 8:LINEPay, 9:auPay, 10:J-Coin Pay, 11:銀聯QR, 12:Alipay+) のラベル配列
 * @export
 */
export const SettlementTypeLabelList = [
  '汎用QR','WechatPay','ALIPay','AEONPay','R Pay','PayPay','メルペイ','d払い','LINEPay','auPay','J-Coin Pay','銀聯QR','Alipay+',
] as const;

